<template>
	<div class="details">
		<Commshop
		 :proData="transmitData"
		  />
		
		<div class="conten_body">  
			<div class="conten_left">
				
            
         <!-- 为什么选择万方？万方有什么优势？ -->
				<div class="con_list">
					<img class="" src="@/assets/images/services/11-1/A61-20190408_01.jpg">
					<img class="" src="@/assets/images/services/11-1/A61-20190408_03.jpg">
					<img class="" src="@/assets/images/services/11-1/A61-20190408_04.jpg">
					<img class="" src="@/assets/images/services/11-1/A61-20190408_05.jpg">
					<img class="" src="@/assets/images/services/11-1/A61-20190408_06.jpg">
					<img class="" src="@/assets/images/services/11-1/A61-20190408_07.jpg">
					<img class="" src="@/assets/images/services/11-1/A61-20190408_08.jpg">
					
					
				</div>
				
				
			</div>
			<!-- right -->
			<Phone/>
			

		</div>
	</div>
</template>

<script type="text/javascript">
import Phone from "@/components/Phone.vue"
import Commshop from "@/components/Commshop.vue"
export default{
	components:{
      Phone,
      Commshop
	},
data(){
	return{
		transmitData:{
			title:"ISO27001信息安全管理体系认证咨询服务",
			content:"万方安全信息安全专家团队拥有多年信息安全管理体系咨询服务和培训经验，曾经为多家跨国公司，高科技企业，一流股份制商业银行、深圳证卷交易所等企业提供过信息安全咨询和培训服务。",
            cc:"组织开展并改进信息安全工作的系统的一套思路、方法，可以被理解为是信息安全管理体系",
			price:'在线咨询',
			url:require('../../assets/images/services/11-1/138_G_1529369156194.jpg')
		}
	}
},
mounted(){

},
methods:{
	

}


};
</script>

<style type="text/css" lang="less" scoped>
.details{
	width:1200px;
	margin:0 auto;

//**/
.conten_body{
	margin-top:30px;
	overflow: hidden;
}
.conten_left{
	width:880px;
	float:left;
	background:#fff;
	box-sizing: border-box;
}
.nav_list{
	height:39px; 
   border-bottom: 1px solid #CFCDCD;
}
.nav_list li{
	float:left;
	width:120px;
	text-align:center;
}
.nav_list li a{
	display: inline-block;
	height:39px;
	font-size: 15px;
	line-height: 39px;
	color: #007CC6;
}
.nav_list li  .a_active{
   color:#007CC6;
   border-bottom:1px solid #007CC6;
}
.con_list{
	// padding:0 35px;
	overflow:hidden;
}
.con_list img{
	width:100%;
}





}


</style>







